export const convertMonthToNumber = (month) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const monthIndex = months.indexOf(month);
  return (monthIndex + 1).toString().padStart(2, "0");
};
